export const privacyPolicyHtml = `
<div style="text-align:left;font-family:Arial, sans-serif;line-height:1.6;color:#333;">
  <p><strong>Last Updated:</strong> October 31, 2025</p>

  <h3>1. Introduction</h3>
  <p>Welcome to Miracle Pace Inc. (“Miracle Pace”, “we”, “our”, or “us”). This Privacy Policy explains how we collect, use, store, and protect your personal information when you use our website, mobile application, and services related to our foreign exchange and financial platform (the “Services”).</p>
  <p>By using our Services, you agree to the collection and use of your information in accordance with this Policy.</p>

  <h3>2. Information We Collect</h3>
  <ul>
    <li><strong>Personal Identification Information:</strong> name, date of birth, address, email, phone number, and government-issued identification.</li>
    <li><strong>Financial and Transaction Information:</strong> banking details, payment records, and currency exchange transactions.</li>
    <li><strong>Verification and Compliance Data (KYC/AML):</strong> information provided for identity verification and anti-money laundering compliance.</li>
    <li><strong>Technical Information:</strong> IP address, browser type, operating system, device identifiers.</li>
    <li><strong>Usage Data:</strong> page visits, session duration, click patterns.</li>
  </ul>

  <h3>3. How We Use Your Information</h3>
  <ul>
    <li>Verify your identity and comply with regulatory requirements (KYC/AML).</li>
    <li>Process currency exchange transactions and payments.</li>
    <li>Communicate with you about your account, updates, and security notifications.</li>
    <li>Improve our Services and enhance user experience.</li>
    <li>Prevent fraudulent or illegal activities and ensure platform security.</li>
    <li>Comply with applicable laws, regulations, and financial reporting obligations.</li>
  </ul>

  <h3>4. Exchange Rates & Payment Information</h3>
  <ul>
    <li>The exchange rates displayed on the platform are for reference only. The actual settlement rate may vary slightly due to platform adjustments, market fluctuations, and fees.</li>
    <li>Stripe processing fees are paid by the customer. By completing a transaction, users acknowledge and accept that the final amount may differ from the displayed rate.</li>
    <li>Miracle Pace is not responsible for differences in amount arising from market volatility, third-party processing, or other objective factors.</li>
    <li>By registering or using the platform, you confirm that you have read and agreed to these terms and acknowledge the above rules.</li>
  </ul>

  <h3>5. Information Sharing and Disclosure</h3>
  <p>We do not sell, rent, or trade your personal information to third parties. However, we may share your data in the following cases:</p>
  <ul>
    <li><strong>Authorized Third-Party Service Providers:</strong> payment processors (Stripe), compliance partners, and cloud hosting providers (AWS).</li>
    <li><strong>Legal and Regulatory Reasons:</strong> when required by law, court order, or regulatory authority.</li>
    <li><strong>Business Transfer:</strong> in case of merger, acquisition, or asset sale, information may be transferred as part of that transaction.</li>
  </ul>

  <h3>6. Data Storage and Third-Party Services</h3>
  <ul>
    <li><strong>KYC Information:</strong> securely stored on AWS cloud servers.</li>
    <li><strong>Banking and Payment Information:</strong> processed through Stripe. The company does not directly store banking information.</li>
    <li>All data handling follows applicable privacy laws, including PIPEDA.</li>
  </ul>

  <h3>7. Data Retention</h3>
  <p>We retain personal information only as long as necessary or as required by law. Once no longer needed, data will be securely deleted or anonymized.</p>

  <h3>8. Data Security</h3>
  <p>We employ encryption, restricted access, and continuous monitoring to protect your data.</p>

  <h3>9. Limitation of Liability for Data Security</h3>
  <p>While we take robust measures, no system is 100% secure. Miracle Pace is not liable for unauthorized access or loss beyond reasonable control.</p>

  <h3>10. Your Rights</h3>
  <p>You have rights to access, correct, delete data, withdraw consent, and file complaints via <a href="mailto:miraclepaceinc@outlook.com">miraclepaceinc@outlook.com</a>.</p>

  <h3>11. Cookies and Analytics</h3>
  <p>Cookies are used for analytics and experience improvement. Disabling may limit functionality.</p>

  <h3>12. Children’s Privacy</h3>
  <p>Our Services are not intended for users under 18. We do not knowingly collect information from minors.</p>

  <h3>13. International Data Transfers</h3>
  <p>Data may be processed in Canada or the US with appropriate safeguards.</p>

  <h3>14. Changes to This Privacy Policy</h3>
  <p>Updates will be posted on our website. Continued use implies acceptance.</p>

  <h3>15. Contact Us</h3>
  <p>Miracle Pace Inc.<br>
  1200 Bay Street, Suite 1201, Toronto, Ontario, Canada<br>
  Email: <a href="mailto:miraclepaceinc@outlook.com">miraclepaceinc@outlook.com</a></p>
</div>
`;
